import Component from 'components/component'
import OuterClick from 'components/outer-click'
import Tooltip from 'components/tooltip'
import { DI } from 'modules'
import React, { useState } from 'react'
import * as buffer from 'utils/buffer'
import * as data from './config'

function ShareListComponent({ entity, actions, common }) {
  const currentUrl = document.location.href

  const copy = () => {
    buffer.copy(currentUrl)
    actions.notifications.createNotification({
      type: 'notify',
      children: common.strings['after_copy_link'],
    })
  }

  return (
    <div className="live-share-list">
      <ItemsShareListComponent
        items={data.listShare(entity)}
        currentUrl={currentUrl}
        style={data.styleCursor}
      />

      <Tooltip content={'Copy link'}>
        <div className="live-share-item">
          <button
            type="button"
            className="live-share__link live-share__link--cl"
            data-tippy-content="Copy link"
            onClick={copy}
          />
        </div>
      </Tooltip>
    </div>
  )
}

function ItemsShareListComponent({ items, style = {}, currentUrl }) {
  return items.map(item => {
    const { Component, ...props } = item
    return (
      <Tooltip
        key={item.ico}
        content={item['data-tippy-content'] || item.content}
      >
        <div className="live-share-item">
          <Component
            {...props}
            url={currentUrl}
            className={`live-share__link live-share__link--${item.ico}`}
            style={style}
          />
        </div>
      </Tooltip>
    )
  })
}

function ShareDropdownComponent({
  title,
  entity,
  actions,
  common,
  styled,
  alignLeft,
}) {
  const [dropdownShow, chengDropdownShow] = useState(false)
  const toggleDropdownBody = () => {
    try {
      navigator.share({
        title: entity.title,
        text: entity.desc,
        url: document.location.href,
      })
      console.log(`${entity.title} shared successfully`)
    } catch (err) {
      chengDropdownShow(!dropdownShow)
      console.error(`Native share has not been opened`)
    }
  }

  const toggleDropdownOnOuter = ev => {
    if (ev.target.dataset.name !== 'share' && dropdownShow) {
      chengDropdownShow(false)
    }
  }

  const currentUrl = document.location.href

  const copy = () => {
    buffer.copy(currentUrl)
    actions.notifications.createNotification({
      type: 'notify',
      children: common.strings['after_copy_link'],
    })
  }

  const style = styled
    ? {
        padding: '5px 25px 5px 10px',
        borderWidth: '1px',
      }
    : {}

  return (
    <div className="live-share-dropdown">
      <div className="dropdown">
        <button
          type="button"
          className="dropdown__head dropdown__head--small"
          onClick={toggleDropdownBody}
          data-name="share"
          style={style}
        >
          {title}
        </button>

        <div
          className={Component.classList(
            'dropdown-body dropdown-body--right dropdown-body--big',
            dropdownShow && '_opened'
          )}
          style={alignLeft ? { left: 0 } : void 0}
        >
          <OuterClick on={toggleDropdownOnOuter}>
            <ul className="dropdown-list">
              <ItemsShareDropdown
                items={data.listShare(entity)}
                currentUrl={currentUrl}
                style={data.styleShare}
              />
              <li className="dropdown-item" style={data.styleCursor}>
                <a className="dropdown__item" onClick={copy}>
                  <span className="dropdown__ico dropdown__ico--cl" />
                  {common.strings['copy_link']}
                </a>
              </li>
            </ul>
          </OuterClick>
        </div>
      </div>
    </div>
  )
}

function ItemsShareDropdown({ items, style, currentUrl }) {
  return items.map(item => {
    const Component = item.Component
    return (
      <li key={item.ico} className="dropdown-item">
        <a className="dropdown__item" style={data.styleDropdownItem}>
          <Component url={currentUrl} style={style} {...item} />
          <span className={`dropdown__ico dropdown__ico--${item.ico}`} />
          {item['data-tippy-content'] || item.content}
        </a>
      </li>
    )
  })
}

export const ShareList = DI(['notifications', 'common'])(ShareListComponent)
export const ShareDropdown = DI(['notifications', 'common'])(
  ShareDropdownComponent
)
